import { z } from "zod";

export const stringToBooleanSchema = z.enum(["true", "false"]).transform((v) => v === "true");

export const tolerantStringToBooleanSchema = stringToBooleanSchema.nullish().transform((v) => v ?? false);
